import { useState } from "react";
import { useAccrueCreancesMutation } from "@/hooks/mutations/useAccrueCreances";

export function useCreanceAccrualAction() {
  const [accrueResult, setAccrueResult] = useState<string | null>(null);
  const accrueMutation = useAccrueCreancesMutation();

  function accrueNow() {
    setAccrueResult(null);
    accrueMutation.mutate(undefined, {
      onSuccess: (data) => setAccrueResult(`${data.inserted} pénalité(s) accumulée(s).`),
    });
  }

  return {
    accrueNow,
    accrueResult,
    isAccruing: accrueMutation.isPending,
  };
}
